import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { CidadeService } from 'src/app/proxy/cidades/cidade.service';

@Injectable({ providedIn: 'root' })
export class CidadeReferenceDataService {
  private mesorregioes$?: Observable<string[]>;
  private estados$?: Observable<string[]>;
  private regioes$?: Observable<string[]>;

  constructor(private readonly cidadeService: CidadeService) {}

  getMesorregioes(): Observable<string[]> {
    if (!this.mesorregioes$) {
      this.mesorregioes$ = this.cidadeService.getMessoregioes().pipe(
        map(values => values ?? []),
        catchError(() => of([])),
        shareReplay(1)
      );
    }

    return this.mesorregioes$;
  }

  getEstados(): Observable<string[]> {
    if (!this.estados$) {
      this.estados$ = this.cidadeService.getEstados().pipe(
        map(values => values ?? []),
        catchError(() => of([])),
        shareReplay(1)
      );
    }

    return this.estados$;
  }

  getRegioes(): Observable<string[]> {
    if (!this.regioes$) {
      this.regioes$ = this.cidadeService.getRegioes().pipe(
        map(values => values ?? []),
        catchError(() => of([])),
        shareReplay(1)
      );
    }

    return this.regioes$;
  }
}
